exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[class^=col-md][data-v-4c6e6bb0]{padding-bottom:0!important}[data-v-4c6e6bb0] .v-text-field.v-text-field--enclosed .v-text-field__details{margin-bottom:0!important}", ""]);

// exports
